import React from "react";
import { Link } from "react-router-dom";
import {
  PodcastContainer,
  PodcastGrid,
  HoverablePodcastCard,
  PodcastImage,
  PodcastContent,
  PodcastDate,
  PodcastTitle,
  PodcastDescription
} from '../Styles/StylespodcastPage.js';
import p1 from '../Images/p1.webp'
import p2 from '../Images/p2.jpeg'
import p3 from '../Images/p3.jpeg'
import p4 from '../Images/p4.jpeg'
import p5 from '../Images/p5.jpeg'
import p6 from '../Images/p6.jpeg'
import p7 from '../Images/p7.jpeg'
import p8 from '../Images/p8.jpeg'
import p9 from '../Images/p9.jpeg'
import p10 from '../Images/p10.webp'
import p11 from '../Images/p11.jpeg'
import p12 from '../Images/p12.jpeg'


const podcasts = [
  {
    id: 1,
    date: "6/12/24",
    title: "Gail Schwartz - President of Roaring Fork Valley Habitat for Humanity",
    description:
      "Andrew and Gail discuss some of the excellent initiatives in the pipeline with Roaring Fork Valley Habitat for Humanity.",
    image: p1,
  },
  {
    id: 2,
    date: "5/22/24",
    title: "Bradley Nelson - CMO of Sotheby's International Realty",
    description:
      "Brad Nelson will be a panelist at the August 15, 2024 event 'The World of Sotheby’s - An Insider’s View'. Andrew and Brad discuss some of the current trends in the global luxury real estate market as well as the various ways Sotheby’s International Realty creates value for its agents and clients.",
    image: p2,
  },
  {
    id: 3,
    date: "5/21/24",
    title: "Peter Kloman - SVP of Sotheby's Collector's Group",
    description:
      "In anticipation of the August 15, 2024 event 'The World of Sotheby’s - An Insider’s View', Andrew and Peter discuss the current environment for auctions at Sotheby’s as well as parallels between the Aspen Real Estate market and luxury artwork auctions.",
    image: p3,
  },
  {
    id: 4,
    date: "4/15/24",
    title: "Sarah Johnson - Real Estate Innovations",
    description:
      "Sarah and Andrew dive into innovative real estate strategies shaping the future of the housing market.",
    image: p4,
  },
  {
    id: 5,
    date: "3/30/24",
    title: "John Doe - Trends in Urban Development",
    description:
      "John shares insights on urban planning and the challenges faced in developing sustainable cities.",
    image: p5,
  },
  {
    id: 6,
    date: "3/10/24",
    title: "Emma Watson - Sustainable Housing",
    description:
      "Emma discusses the importance of sustainability in modern housing projects.",
    image: p6,
  },
  {
    id: 7,
    date: "2/25/24",
    title: "Chris Evans - Luxury Market Trends",
    description:
      "Chris explores the latest trends in the global luxury market and their implications.",
    image: p7,
  },
  {
    id: 8,
    date: "2/10/24",
    title: "Olivia Brown - Affordable Housing Challenges",
    description:
      "Olivia sheds light on the difficulties in creating affordable housing in urban areas.",
    image: p8,
  },
  {
    id: 9,
    date: "1/15/24",
    title: "David Green - Future of Real Estate Tech",
    description:
      "David talks about cutting-edge technologies reshaping the real estate industry.",
    image: p9,
  },
  {
    id: 10,
    date: "12/5/23",
    title: "Laura Harris - Future of Smart Cities",
    description:
      "Laura discusses the impact of smart technologies on city development and the role of urban planning in fostering innovation.",
    image:p10,
  },
  {
    id: 11,
    date: "11/20/23",
    title: "Tom Richards - Green Building Strategies",
    description:
      "Tom talks about sustainable building practices and how the real estate industry is responding to the demand for green construction.",
    image: p11,
  },
  {
    id: 12,
    date: "10/18/23",
    title: "Sophia Lee - Real Estate Investment Strategies",
    description:
      "Sophia shares her insights on investment strategies and the potential of real estate as a long-term financial asset.",
    image: p12,
  },
];


const PodcastPage = () => {
  return (
    <PodcastContainer>
      <PodcastGrid>
        {podcasts.map((podcast) => (
          <HoverablePodcastCard key={podcast.id}>
            <Link to={`/podcast/${podcast.id}`}>
              <PodcastImage src={podcast.image} alt={podcast.title} />
              <PodcastContent>
                <PodcastDate>{podcast.date}</PodcastDate>
                <PodcastTitle>{podcast.title}</PodcastTitle>
                <PodcastDescription>{podcast.description}</PodcastDescription>
              </PodcastContent>
            </Link>
          </HoverablePodcastCard>
        ))}
      </PodcastGrid>
    </PodcastContainer>
  );
};

export default PodcastPage;
